import { render, staticRenderFns } from "./Guide3.vue?vue&type=template&id=ecc36868"
import script from "./Guide3.vue?vue&type=script&lang=js"
export * from "./Guide3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports